import { Job } from '../../jobs-module/models/job.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobListingItem } from '../../jobs-module/models/listing.model';
import { EditorText } from '../../shared-module/components/mj-text-editor/mj-text-editor.component';

@Component({
  selector: 'mj-job-header',
  templateUrl: './job-header.component.html',
  styleUrls: ['./job-header.component.scss'],
})
export class JobHeaderComponent implements OnInit {
  @Input() public job: Job;
  @Input() public listingItem: JobListingItem;
  @Output() public onItemChanged = new EventEmitter<JobListingItem>();
  @Output() public onItemScheduledForRemoval = new EventEmitter<
    JobListingItem
  >();

  isImgPickerOn: boolean;
  isColorPickerOn;
  ratio = [16, 9];

  ngOnInit(): void {
    if (!this.listingItem.background_image_url && this.job && this.job.image) {
      this.listingItem.background_image_media_id = this.job.image_media_id;
      this.onItemChanged.emit({
        ...this.listingItem,
        background_image_media_id: this.job.image_media_id,
        background_image_url: this.job.image,
      });
    }
  }

  public getBackgroundImage(): string {
    const listingImage = this.listingItem.background_image_url
      ? `url(${this.listingItem.background_image_url.split('?')[0]})`
      : '';
    if (this.job) {
      return listingImage
        ? listingImage
        : this.job.image
        ? `url(${this.job.image.split('?')[0]})`
        : null;
    } else {
      return listingImage;
    }
  }

  saveTitle($event: EditorText) {
    this.onItemChanged.emit({
      ...this.listingItem,
      title_rich: $event.rich,
      title: $event.plain,
    });
  }

  savePitch($event: EditorText) {
    this.onItemChanged.emit({
      ...this.listingItem,
      subtitle_rich: $event.rich,
      subtitle: $event.plain,
    });
  }
}
